import { useState } from 'react'
import { PasswordForm } from '../auth/PasswordForm'

/**
 * Changing your own password, because you want to rather than because you are being made to.
 *
 * Until now the only way through `POST /api/v1/auth/password` was the forced-change takeover, so an
 * endpoint that has always been open to every signed-in account had exactly one caller and no way to
 * reach it deliberately. Somebody who simply wanted to rotate their password could not.
 *
 * On Settings rather than a route of its own, for the reason that screen's own comment gives: these
 * are "the settings that belong to a person rather than to the fleet", and a password is the most
 * person-scoped thing in the product. Settings is also the one entry in the account menu with no
 * role requirement - which is exactly the reach this needs, platform administrators included - so a
 * new route would have had to redeclare that property and teach three gates about itself.
 *
 * A tab of that screen since the four cards were split up, and with no heading of its own: the tab
 * strip already says "Your password" (D-429).
 */
export function PasswordCard() {
  const [changed, setChanged] = useState(false)

  return (
    <div className="card">
      <div className="card-body">
        <p className="muted" style={{ marginTop: 0 }}>
          Change it whenever you like. You will be asked for your current one even though you are
          already signed in, and you stay signed in afterwards.
        </p>

        {/*
          Said on the page rather than discovered. The takeover navigates away on success so it needs
          no confirmation; this stays exactly where it was, and a screen that looks identical before
          and after is one somebody presses twice.
        */}
        {changed && (
          <div className="banner success" role="status" data-testid="password-changed">
            Your password has been changed.
          </div>
        )}

        <PasswordForm
          submitLabel="Change password"
          savingLabel="Changing…"
          onChanged={() => setChanged(true)}
        />
      </div>
    </div>
  )
}
